import Swiper from "swiper";

class ModuleBlockSlider {
  constructor() {
    this.component = document.querySelectorAll(
      '[data-component="module-block-slider"]'
    );
    this._init();
  }

  _init() {
    if (this.component) {
      for (let element of this.component) {
        let swiper = null;
        let trigger = element.querySelector(
          '[data-trigger="module-block-slider"]'
        );

        // If swiper is init before image is loaded, we reload swiper
        // (when lazyload images with data-visibility)
        const firstImage = trigger.querySelector("img");

        if (firstImage) {
          firstImage.onload = () => {
            if (swiper) {
              swiper.update();
            }
          };
        }

        swiper = new Swiper(trigger, {
          slidesPerView: 1,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          preloadImages: false,
          lazy: {
            loadOnTransitionStart: true
          }
        });
      }
    }
  }
}

export const moduleBlockSlider = new ModuleBlockSlider();
